import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight, faArrowRightFromBracket, faArrowUp, faBarsProgress, faDna, faDotCircle, faEye, faFile, faFileArrowDown, faFileArrowUp, faFilePdf, faFilePen, faPenToSquare, faPrint, faScaleBalanced } from '@fortawesome/free-solid-svg-icons';
import { DialogModule } from 'primeng/dialog';
import { environment } from 'src/environments/environment';
import { FormPreviewComponent } from "../../form-preview/form-preview.component";
import {NgxPrintModule} from 'ngx-print';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { ActivatedRoute, Router } from '@angular/router';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-data-form-table',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, DialogModule, FormPreviewComponent, NgxPrintModule,BadgeModule],
  templateUrl: './data-form-table.component.html',
  styleUrl: './data-form-table.component.scss'
})
export class DataFormTableComponent {



  @Input() data: any[] = [];
  @Input('tipo') tipo: any;
  @ViewChild(FormPreviewComponent,{static:false}) printContent: FormPreviewComponent | undefined;
  faCircle = faDna
  faRisultato = faFileArrowDown
  visible: boolean = false;
  currentPage = 1;
  itemsPerPage =6;
  paginatedData:any = [];
  totalPages: number = 0;
  position: string = 'bottom';
  form: any;
  compositionId: any;
  ehrId:any;
  hidden: string = 'block';
  faPrint=faPrint;
  faDocument=faFilePdf;
  faGoTo: IconProp=faFilePen;
  faEye: IconProp=faEye;
  codiceFiscale: string='';
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      
      this.currentPage = 1;  
      this.updatePaginatedData();
    }
  }

  showDialog(item: any, tipo: any) {
    switch (tipo) {
      case 'Richiesta Sequenziamento':
        this.form = environment.forms.find(form => form.name === 'Richiesta_Sequenziamento_DNA');
        break;
      case 'Risultato Sequenziamento':
        this.form = environment.forms.find(form => form.name === 'Sequenziamento_DNA');
        break;
      case 'Richiesta Cariotipo':
        this.form = environment.forms.find(form => form.name === 'Richiesta_Cariotipo');
        break;
      case 'Risultato Cariotipo':
        this.form = environment.forms.find(form => form.name === 'Analisi_Cariotipo');
        break;
    }

    this.compositionId = item.composition_uid_value;
    this.ehrId = item.ehrid;
    this.visible = true;
    this.hidden = 'block';

  }

  closeModal() {
    this.compositionId = undefined;
    this.ehrId = undefined;
  }

  stampa() {
    const printContent = this.printContent?.printSection?.nativeElement.innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent || '';
    window.print();
    document.body.innerHTML = originalContent;
  }

  downloadPDF() {
    const data = document.getElementById('print-section');
    console.log(data);
    if (data) {
      html2canvas(data).then(canvas => {
        const imgWidth = 208;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        const contentDataURL = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const position = 0;
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        pdf.save(this.ehrId + '.pdf');
      });
    }
  }
  constructor(private router: Router,private activatedRouter: ActivatedRoute){
    this.activatedRouter.params.subscribe(params => {
      this.codiceFiscale = params['codiceFiscale'];
    });
   
  }
  ngOnInit(){
    this.updatePaginatedData()
  }
  goToPage(tipo: string,id: string,ehrId: string) {
    console.log(this.tipo);
    if (this.tipo === 'Richiesta Sequenziamento') {
      this.router.navigate(
        ['/sequenziamento'],
        {
          queryParams: { compositionId: id,ehrId:ehrId }
        }
      );
    }
    if (this.tipo==='Richiesta Cariotipo') {
      this.router.navigate(
        ['/cariotipo'],
        {
          queryParams: { compositionId: id,ehrId:ehrId }
        }
      );
    }
  }
  updatePaginatedData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.data.slice(startIndex, endIndex);
    this.totalPages = Math.ceil(this.data.length / this.itemsPerPage);
    console.log(this.paginatedData,this.totalPages)
  }
  goToPagina(arg0: number) {
    this.currentPage = arg0;
    this.updatePaginatedData();
    }
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updatePaginatedData();
      }
    }
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updatePaginatedData();
      }
    }
}

